//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterTop from '~/components/footer/footerTop.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'

export default {
  components: {
    FooterTop,
    FeatureContainer,
    DescriptionCard
  },
  head () {
    return {
      title: this.$t('footer.about.partners').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
